export default __webpack_public_path__ + "static/media/heroBG.6f3ecf09.png";